import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import Header from 'elements/stateless/header';
import Button from 'elements/stateless/button';
import EmailField from 'elements/statefull/emailField';
import PasswordField from 'elements/statefull/passwordField';

import configs from 'configs';
import api from 'helpers/api';
import Footer from '../footer';
import LeftText from '../leftText';
import toaster from 'helpers/toaster';
import { enterKeyCode } from 'constants/enterKey';
import { dispatchLoginEvent } from 'helpers/events';
import getQueryVariable from 'helpers/urlQueryParamsParser';

class SignIn extends React.PureComponent {

  static contextTypes = {
    router: PropTypes.object,
  };

  mainSiteUrl = '';

  constructor(props, context) {
    super(props, context);

    this.state = {
      email: '',
      password: '',
      errors: {},
      needsToLoad: false,
      showPassword: false,
    };

    if (configs.isLoggedIn) {
      this.context.router.history.push('/');
    };
  }

  componentDidMount() {
    const query = this.context.router.route.location.state 
      ? this.context.router.route.location.state.from.search 
        : this.context.router.route.location.search;
    const emailConfirmed = getQueryVariable(query, 'emailConfirmed');
    const expired = getQueryVariable(query, 'expired');
    const mainSiteUrl = getQueryVariable(query, 'mainSiteUrl');

    if (expired) {
      toaster('Email link is expired');
      return;
    }

    if (emailConfirmed) {
      toaster('Email confirmed. Please sign in', true);

      if (mainSiteUrl !== '/' && mainSiteUrl) {
        window.location.href = mainSiteUrl;
      }
    }
  }

  changeHandler = event => {
    this.setState({
      [event.target.dataset.key]: event.target.value,
    });
  };

  keyPressHandler = event => {
    if (event.keyCode === enterKeyCode || event.which === enterKeyCode) {
      this.submit();
    };
  };

  gotoForgotPassword = () => {
    this.context.router.history.push('/resetPassword');
  };

  gotoRegistration = () => {
    this.context.router.history.push('/registration');
  };

  setErrors = (hasErrors, key) => {
    this.setState({
      errors: {
        ...this.state.errors,
        [key]: hasErrors,
      }
    });
  };

  handlePostLogin = returnUrl => {
    if (returnUrl) {
      window.location.href = returnUrl;
    } else {
      dispatchLoginEvent();
      this.context.router.history.push('/');
    };
  };

  submit = () => {
    const { email, password } = this.state;
    if (email && password && !this.hasErrors()) {

      this.setState({ needsToLoad: true });

      const { returnUrl } = configs;
      const options = {
        email,
        password,
      };

      if (returnUrl) {
        options.returnUrl = returnUrl;
      }

      !this.state.needsToLoad && api.create('/auth/login', options).then(response => {
        this.setState({ needsToLoad: false });
        if (response) {
          const { requestTwoFactor, qrUrl, requestEmailConfirmation } = response || {};
          if (requestEmailConfirmation) {
            this.context.router.history.push('/registration', { emailNotConfirmed: true,email });
            return;
          }
          configs.authenticated = true;
          window.sessionStorage.setItem('authenticated', true);

          if (requestTwoFactor) {
            this.context.router.history.push('/authentication', { email, returnUrl, qrUrl });
          } else {
            const analytics = window.analytics;
            if (analytics) {
              const anonymousId = analytics.user().anonymousId();

              return analytics.alias(email, anonymousId, {}, () => {
                analytics.identify(anonymousId, { email });
                this.handlePostLogin(returnUrl);
              });
            }
            return this.handlePostLogin(returnUrl);
          }
        }
      })
    }
  };

  hasErrors = () => Object.values(this.state.errors).some(error => error);

  render() {
    const { email, password } = this.state;
    const isDisabled = !email || !password || this.hasErrors();

    return (
      <ul className="sso-grid">
        <li>
          <LeftText />
        </li>
        <li>
          <div className='splash-box-holder'>
            <div className="splash-box">
              <div className='icon-bet' />
              <Header title="Sign in" subtitle="to continue" />
              <div className="sso-form">
                <EmailField
                    data-key="email"
                    errorKey="email"
                    value={this.state.email}
                    setErrors={this.setErrors}
                    onChange={this.changeHandler}
                    onKeyPress={this.keyPressHandler}
                />
                <PasswordField
                    noValidate
                    name="Password"
                    errorKey="password"
                    data-key="password"
                    setErrors={this.setErrors}
                    value={this.state.password}
                    onChange={this.changeHandler}
                    onKeyPress={this.keyPressHandler}
                />
              </div>
              <ul className="sso-f-actions">
                <li>
                  <span className="sf-action" onClick={this.gotoForgotPassword}>
                    Forgot password?
                  </span>
                </li>
                <li>
                  <Button
                      title="Sign in"
                      onClick={this.submit}
                      icon="icon-long-arrow-right"
                      needsToLoad={this.state.needsToLoad}
                      className={classnames('button', 'right-arrow-animation', { disabled: isDisabled })}
                  />
                </li>
              </ul>
              <Footer />
            </div>
          </div>
        </li>
      </ul>
    )
  }
};

export default SignIn; 
